import * as React from 'react';

import { useQuery } from '@apollo/client';

import ConsumerMyPageHeaderContext from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import ConsumerMyPageHeaderQuery from 'bundles/composable-page-header-consumer/queries/ConsumerMyPageHeaderQuery.graphql';
import type {
  ConsumerMyPageHeaderQuery as ConsumerMyPageHeaderQueryType,
  ConsumerMyPageHeaderQueryVariables,
} from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';

const ConsumerPageHeaderBffProvider = ({ children }: { children: React.ReactNode }) => {
  const { data, error } = useQuery<ConsumerMyPageHeaderQueryType, ConsumerMyPageHeaderQueryVariables>(
    ConsumerMyPageHeaderQuery,
    {
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
    }
  );

  return (
    <ConsumerMyPageHeaderContext.Provider
      value={{
        myPageHeader: data?.PageHeader?.queryMyPageHeader,
        error,
      }}
    >
      {children}
    </ConsumerMyPageHeaderContext.Provider>
  );
};

export default ConsumerPageHeaderBffProvider;
